import { useEffect } from "react";

export const useScrollToTop = (deps: { pathname: string }) => {
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, [deps.pathname]);
};
